<template>
  <div>
    <h3>Artikel:</h3>
    <hr>
    <ArticleNav />
    <div v-if="!page">
      <div v-if="total < 15">
        0-{{ total }} von {{ total }}
      </div>
      <div v-else>
        0-15 von {{ total }}
      </div>
    </div>
    <div v-else-if="(page) * 15 < total">
      {{ (page - 1) * 15 + 1 }}-{{ (page) * 15 }} von {{ total }}
    </div>
    <div v-else>
      {{ (page - 1) * 15 + 1 }}-{{ total }} von {{ total }}
    </div>
    <b-list-group
      style="border: 1px lightgrey solid;"
      flush
    >
      <b-skeleton-wrapper :loading="false">
        <template v-slot:loading>
          <b-card
            v-for="x in new Array(15)"
            :key="x"
          >
            <b-skeleton width="85%" />
            <b-skeleton width="55%" />
          </b-card>
        </template>

        <ArticleListEntry
          v-for="article in articles"
          :key="article.id"
        />
      </b-skeleton-wrapper>
    </b-list-group>
    <div style="margin-bottom: 20px" />
  </div>
</template>

<script>
import ArticleListEntry from './ArticleListEntry'
import { mapGetters } from 'vuex'
import ArticleNav from './ArticleNav'

export default {
  name: 'ArtikelListe',
  components: {
    ArticleNav,
    ArticleListEntry
  },
  computed: {
    ...mapGetters([
      'getStoredArticlesByPage',
      'getTotalArticles'
    ]),
    articles () {
      return this.getStoredArticlesByPage(parseInt(this.$route.query.page))
    },
    total () {
      return this.getTotalArticles
    },
    page () {
      return this.$route.query.page
    }
  },
  watch: {
    '$route.query.page' () {
      this.$store.dispatch('getArticles', this.$route.query.page)
    }
  },
  mounted () {
    this.$store.dispatch('getArticles', this.$route.query.page)
  }
}
</script>

<style scoped>

</style>
